import React from "react";
import Seo from "@/components/Seo";

const sections = [
  {
    title: "1. Information We Collect",
    body: "We collect information you provide directly (name, email, phone, resume content, employment history, application data) and information collected automatically through cookies and analytics when you use our website and portals."
  },
  {
    title: "2. How We Use Information",
    body: "Personal data is used solely to deliver our coaching, placement and payroll services: matching candidates to roles, communicating updates, running background checks with your consent, and administering payroll and statutory compliance on behalf of client organizations."
  },
  {
    title: "3. Sharing With Third Parties",
    body: "We share candidate profiles only with client organizations to which you have expressly applied. Payroll data is shared with statutory authorities (EPFO, ESIC, Income Tax) strictly as required by Indian law. We never sell personal data."
  },
  {
    title: "4. Data Retention",
    body: "Candidate profiles are retained for the duration of active engagement plus 24 months for future opportunities, unless you request earlier deletion. Payroll and statutory records are retained for 8 years in accordance with Indian labour law."
  },
  {
    title: "5. Your Rights",
    body: "You may request access, correction, portability or deletion of your personal data at any time by writing to info@ravemora.com. We will action verified requests within 30 days."
  },
  {
    title: "6. Security",
    body: "Ravemora operates ISO 27001-aligned processes, encrypts data in transit and at rest, and restricts access on a strict need-to-know basis. Any breach affecting personal data will be notified within 72 hours."
  },
  {
    title: "7. Contact",
    body: "For any privacy queries, write to our Data Protection Officer at info@ravemora.com or call +91 74835 00550. Ravemora Global Private Limited, Bengaluru, India."
  },
];

export default function Privacy() {
  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-24" data-testid="privacy-page">
      <Seo path="/privacy" title="Privacy Policy" description="How Ravemora Global collects, uses and protects personal data of candidates, clients and website visitors." noindex={false} />
      <div className="label-eyebrow text-navy/60">Legal</div>
      <h1 className="serif-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-tight">Privacy Policy</h1>
      <p className="text-navy/50 mt-4">Effective date: 1 January 2026</p>
      <div className="hairline my-10" />
      <div className="space-y-10">
        {sections.map((s) => (
          <section key={s.title}>
            <h2 className="serif-display text-2xl md:text-3xl text-navy">{s.title}</h2>
            <p className="mt-3 text-navy/75 leading-relaxed">{s.body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
